module.exports = __webpack_public_path__ + "static/entreprise-9754a8d9d51909595c56b2a0340e007d.svg";